import React, { FC } from 'react';

import { useSkipLinks } from '@evinced-private/ui-common';

import { MobileSdkError } from 'src/apps/mobile-sdk/components/MobileSdkError';
import { MobileSdkSessionNotSyncedYetPopup } from 'src/apps/mobile-sdk/components/MobileSdkSessionNotSyncedYetPopup';
import { useMobileSdkSummaryDataQuery } from 'src/apps/mobile-sdk/hooks/useMobileSdkSummaryDataQuery';
import { useMobileSdkTestsQuery } from 'src/apps/mobile-sdk/hooks/useMobileSdkTestsQuery';
import { MobileSdkTestsPageHeader } from 'src/apps/mobile-sdk/pages/all-tesks/sections/header/MobileSdkTestsPageHeader';
import { MobileSdkTestsSummary } from 'src/apps/mobile-sdk/pages/all-tesks/sections/summary/MobileSdkTestsSummary';
import { MobileSdkTestsTable } from 'src/apps/mobile-sdk/pages/all-tesks/sections/table/MobileSdkTestsTable';
import { HorizontalDivider } from 'src/common/components/horizontal-divider/HorizontalDivider';
import { MOBILE_SDK_TESTS_TABLE_ID } from 'src/common/pages/dashboards-container/dashboard_consts';
import { showRecentTestKey } from 'src/common/providers/dashboard/TablesCustomStateHelper';
import { useTableState } from 'src/common/providers/dashboard/TableStateProvider';

export const MobileSdkPlatformPage: FC = () => {
	const { getTableStateById, onFilterChange } = useTableState();
	const tableState = getTableStateById(MOBILE_SDK_TESTS_TABLE_ID);
	const { filters, tableSort, paginationInfo, customParams } = tableState;
	const showRecentTest = customParams?.[showRecentTestKey] ?? false;

	const summaryDataQuery = useMobileSdkSummaryDataQuery(filters, showRecentTest);
	const testsQuery = useMobileSdkTestsQuery({
		showRecentTest,
		page: paginationInfo.page,
		pageSize: paginationInfo.sizePerPage,
		sort: tableSort?.[0],
		filters
	});

	useSkipLinks(!testsQuery.isLoading || !summaryDataQuery.isLoading);

	const unfilteredTotal = testsQuery.data?.unfilteredTotal ?? 0;
	const showError = testsQuery?.isError || summaryDataQuery?.isError;
	const isNodataError =
		!testsQuery?.isLoading && !testsQuery?.isPreviousData && unfilteredTotal === 0;

	if (showError) {
		return <MobileSdkError />;
	}

	if (isNodataError) {
		return (
			<>
				<MobileSdkError isNoData />
				<MobileSdkSessionNotSyncedYetPopup />
			</>
		);
	}

	return (
		<div className="mobile-sdk-tests-page">
			<MobileSdkTestsPageHeader
				filters={filters}
				onFilterChange={onFilterChange}
				showRecentTest={showRecentTest}
			/>
			<HorizontalDivider />
			<MobileSdkTestsSummary
				data={summaryDataQuery.data}
				isLoading={summaryDataQuery.isLoading}
				selectedPeriodLabel={filters.sessionsPeriod?.[0]?.label}
			/>
			<MobileSdkTestsTable testsQuery={testsQuery} unfilteredTotal={unfilteredTotal} />
			<MobileSdkSessionNotSyncedYetPopup />
		</div>
	);
};
